<script setup lang="ts">
import EventMarket from "~/components/layout/TrackRacing/Shared/Market/EventMarket.vue";
import { useBetbook } from "~/store/betbook";
import { IOutcome } from "~/types/sports/outcome";

interface SpecialMarketsProps {
	raceWinnerOutcome: IOutcome;
	marketsOnMainView: string[] | undefined;
}
const store = useBetbook();
const props = defineProps<SpecialMarketsProps>();
const specialMarkets = computed(() => {
	const markets = [...store.markets.values()];
	return markets.filter(
		({ name, marketId, eventId }) =>
			!name.includes("Race Winner") && !props.marketsOnMainView?.includes(marketId) && props.raceWinnerOutcome.eventId === eventId
	);
});
const outcomes = computed(() => {
	return [...store.outcomes.values()];
});
</script>
<template>
	<div
		v-for="market in specialMarkets"
		class="mb-2 mt-1 bg-light-50 dark:bg-dark-800 rounded-md p-1 font-bold text-xs flex justify-between items-center"
	>
		<div class="px-1">{{ market.displayName }}</div>
		<EventMarket
			:outcome="
				outcomes.find(
					(outcome) =>
						outcome.marketId === market.marketId &&
						outcome.displayName === raceWinnerOutcome.displayName &&
						outcome.isTradingActive &&
						outcome.shouldDisplay
				)
			"
			:eventId="market.eventId"
			:market="market"
			:key="`${market.eventId}`"
		/>
	</div>
</template>
